<template>
  <div class="vx-row">
    <div class="w-full vx-col">
      <vx-card class="">
        <template slot="actions">
          <div class="flex">
            <excel-download :name="'other-service-sheet'"/>
            <vs-button v-can="'create-edit-other-suppliers'"  @click.stop="onClickAdd" class="mr-4"  color="primary" type="filled">create service</vs-button>
          </div>
        </template>
        <div id="other-supplier-services-table" class="vx-row">
          <div class="w-full vx-col">
            <vs-input icon-pack="feather" icon="icon-search" placeholder="Search"
                      v-model="filters['search']"
                      class="is-label-placeholder px-3 pb-5 w-full md:w-1/3 xl:w-1/7 rounded-full" />
            <vs-table stripe sort class="mt-8" :data="incoterms">
              <template slot="thead">
                <vs-th width="25%">Service/Product Name</vs-th>
                <vs-th width="25%">Category Name</vs-th>
                <vs-th width="35%">Description</vs-th>
                <vs-th width="15%">ACTION</vs-th>
              </template>

              <template slot-scope="{data}">
                <vs-tr class="cursor-pointer" @click.native="onClickUpdate(data[indextr].id)" :key="indextr" v-for="(tr, indextr) in data">

                  <vs-td :data="data[indextr].name">
                    {{ data[indextr].name }}
                  </vs-td>

                  <vs-td :data="data[indextr].category.name">
                    {{ data[indextr].category.name || 'N/A' }}
                  </vs-td>

                   <vs-td :data="data[indextr].description">
                    {{ data[indextr].description.substr(0, 150) }} ...
                  </vs-td>

                  <vs-td :data="data[indextr].name">
                    <div class="justify-start vx-row">
                      <vx-tooltip v-can="'create-edit-other-suppliers'"  text="View/Update" position="left">
                        <vs-button @click.stop="onClickUpdate(data[indextr].id)"  class="ml-3"
                                   size="small" color="warning" type="border" icon-pack="feather" icon="icon-edit-2"></vs-button>
                      </vx-tooltip>
                      <vx-tooltip v-can="'delete-other-supplier-services-&-categories'" text="Remove" position="left">
                        <vs-button @click.stop="openConfirm(data[indextr].id)" class="ml-3"
                                   size="small" color="danger" type="border" icon-pack="feather" icon="icon-trash-2"></vs-button>
                      </vx-tooltip>
                    </div>
                  </vs-td>

                </vs-tr>
              </template>

            </vs-table>
            <vs-pagination
              v-on:changeMaxItems="changePage"
              :size-array="meta.total ? meta.total : 20"
              :max-items="perPage"
              description-body="Rows per page"
              description-connector="of"
              description-title="Records"
              description
              :description-items="descriptionItems"
              :total="(meta.last_page)? meta.last_page : 0"
              v-model="page"  class="p-5">
            </vs-pagination>


          </div>
        </div>
      </vx-card>
    </div>
    <create-other-supplier-services-pop-up ref="createOtherSupplierServicesPopUp"/>
  </div>
</template>

<script>
  import {RepositoryFactory} from '@/repository/RepositoryFactory';
  import AddNewIncotermsPopUp from "@/components/popups/settings/incoterms/AddNewIncotermsPopUp";
  import CreateOtherSupplierServicesPopUp
    from "@/components/popups/other-suppliers/services/CreateOtherSupplierServicesPopUp";

  import Filter from '@/mixins/filter';
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  import {defaultPagination, perPageList} from "@/constants/config";

  const IncotermRepository = RepositoryFactory.get('incoterm');
  const OtherSupplierRepository = RepositoryFactory.get('other_supplier');
  export default {
    name: "OtherSupplierServices",
    data() {
      return {
        supplier_id: null,
        incoterms: [],
        filters: {},
        page : 1,
        total: 0,
        meta : {},
        sort : '',
        perPage: defaultPagination,
        descriptionItems: perPageList,
      }
    },
    components: {
      AddNewIncotermsPopUp,
      CreateOtherSupplierServicesPopUp,
    },
    methods: {
      async refreshData() {
        await this.fetchServices()
      },
      async fetchServices() {
        await this.$vs.loading({
          container: '#other-supplier-services-table',
          scale: 0.45
        })
        this.supplier_id = this.$route.params.id ? this.$route.params.id : null
        let data = {}
        if(!!this.supplier_id) {
          data = (await OtherSupplierRepository.getListOfServices(this.supplier_id, this.page, this.filterQuery, this.perPage, this.sort)).data
        } else {
          data = (await OtherSupplierRepository.getListOfServices(null, this.page, this.filterQuery, this.perPage, this.sort)).data
        }
        this.incoterms =  data.data
         this.meta = data.meta
        this.$vs.loading.close('#other-supplier-services-table > .con-vs-loading')
      },
      async onClickAdd() {
        await this.$refs.createOtherSupplierServicesPopUp.openPopup(this.supplier_id, null)
      },
      async onClickUpdate(id) {
        await this.$refs.createOtherSupplierServicesPopUp.openPopup(this.supplier_id, id)
      },
      openConfirm(id) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: `Confirm`,
          text: 'Are you sure you want to delete this ?',
          accept: this.onClickDelete,
          parameters: [id]
        })
      },
      async onClickDelete(params) {
        try {
          await OtherSupplierRepository.deleteServices(params[0])
          await this.fetchServices()
          await this.showSuccessMessage('Service Deleted!');
        }catch (e) {
            this.convertAndNotifyError(e)
        }
      },
      filterQueryUpdate (){
        this.fetchServices()
      },

      handleChangePage(page) {
        this.page=page;
        this.fetchServices()
      },
      handleSort(key, active) {
        if(key){
          active = (active==='desc')? "-":'';
          this.sort=active+key;
          this.fetchServices()
        }
      },
      changePage(index) {
        this.perPage = this.descriptionItems[index]
      },
    },
    async mounted() {

    },
    mixins: [Filter, SuccessMessage, ErrorMessages],
     watch : {
      page(){
        this.fetchServices()
      },
      perPage() {
        this.fetchServices()
      }
    }
  }
</script>

<style scoped>

</style>
